/* eslint-disable @typescript-eslint/no-explicit-any */
import { integrations } from '../constants/analytics';
import { shouldEnableAnalytics } from './utils';
import logger from './logger';

// Client events
export const FORM_FOCUS = Object.freeze({
  EMAIL: 'email',
  USERNAME: 'username',
  PASSWORD: 'password',
  DATACENTER: 'datacenter',
  CONTACT_CONSENT: 'contactconsent',
  SUBMIT: 'submit',
  GOOGLE_SUBMIT: 'googlesubmit',
});

export const SIGNUP_TYPE = Object.freeze({
  EMAIL: 'email',
  GITHUB: 'github',
  GOOGLE: 'google',
});

const PAGE_LOADED = 'Sign Up - Page Loaded';

export const GO_TO_EXISTING_USER_LOGIN = 'Sign up - Existing user login';
export const GO_TO_EMAIL_LOGIN = 'Sign Up - Email Login';
export const GO_TO_RESET_PASSWORD = 'Sign Up - Reset Password';

// platform configurator events
export const PLATCONFIG_PAGE_LOADED = 'Page Viewed';
export const OBJECT_CLICKED = 'Object Clicked';

const isAnalyticsEnabled = shouldEnableAnalytics();
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const track = (eventName: string, properties: { [key: string]: any } = {}): void => {
  if (isAnalyticsEnabled) {
    // Segment event tracking https://segment.com/docs/connections/spec/track/
    window.analytics.track(eventName, properties, { integrations });
  } else {
    // Output the same data to `log` for testing
    logger.debug(
      {
        event_name: eventName,
        properties,
        integrations,
      },
      '[analytics-client.ts] track debug log',
    );
  }
};

export const trackPage = (url: string): void => {
  if (isAnalyticsEnabled) {
    // segment analytics page load
    window.analytics.track(PAGE_LOADED, null, { integrations });
    // google-tag-manager analytics page load
    window.dataLayer.push({
      event: 'pageview',
      page: url,
    });
  }
};

export type IdentifyType = (newId: string | null, ipAddress?: string) => void;
export const identify: IdentifyType = (newId, ipAddress) => {
  if (isAnalyticsEnabled) {
    const traits = ipAddress ? { ipAddress } : null;
    window.analytics.identify(newId, traits, {
      integrations,
    });
  }
};
